import {Component, OnInit} from '@angular/core';
import {Title, Meta} from '@angular/platform-browser';
import {Router} from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'Milmedia';

  constructor(public router: Router, private tittleService: Title, private meta: Meta) {
  }

  ngOnInit() {
    this.tittleService.setTitle(this.title);
    this.meta.addTag({name: 'author', content: 'registech'});
    this.meta.addTag({name: 'robots', content: 'index, follow'});
    this.meta.addTag({name: 'keywords', content: 'Angular blog'});
    this.meta.addTag({name: 'description', content: 'creating angular blog'});
    const lang = localStorage.getItem('lang');
    if (!lang) {
      localStorage.setItem('lang', 'hy');
    }
  }
}
